import { createContext, useContext } from 'react';

export const FieldContext = createContext(null);

export const FieldProvider = FieldContext.Provider;

export const useFieldContext = () => useContext(FieldContext);
